import { render } from "./CardEmptyStateChallengeRequests.vue?vue&type=template&id=1dd95f8b&scoped=true"
import script from "./CardEmptyStateChallengeRequests.vue?vue&type=script&lang=js"
export * from "./CardEmptyStateChallengeRequests.vue?vue&type=script&lang=js"

import "@/css/components/card-empty-state-challenge-requests.css?vue&type=style&index=0&id=1dd95f8b&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd95f8b"]])

export default __exports__